export default __webpack_public_path__ + "static/media/desktop-hero-image.c63e6d07.png";